import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { Constants } from '../constants/constants';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { RequestOwnership } from '../constants/RequestOwnership';
import { SupportApiService } from '../service/support-api.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit, OnDestroy {

  @ViewChild('addTicketDetailsForm', { static: true }) public addTicketDetailsForm: NgForm;
  @ViewChild('addAttachmentInput') addAttachmentInput: ElementRef;

  accountCategory: string;
  accountType: string;
  tickets: Array<any> = new Array();
  ticketFormData;
  loggedInUser: any = {};
  loggedInUserRole: string;
  supportUser: any;
  requestCategories;
  requestTypeMap: Map<string, string> = new Map();
  priorities: Array<any> = new Array();

  maxIssueSize: number = 10;
  nextIndexPointer: number;
  totalIssues: number;
  isLastPage: boolean = false;

  masterTicketList: Array<any> = new Array();

  //filter options
  statusFilterOptions: Set<string> = new Set();
  requestCategoryFilterOption: Set<string> = new Set();
  priorityFilterOption: Set<string> = new Set();

  sortType = ["DESCENDING", "ASCENDING"];
  selectedSeveritySortType = null;
  selectedStatusSortType = null;
  selectedDateSortType = null;
  isLoggedIn: boolean = false;
  isAdmin: boolean = false;
  isDeveloper: boolean = false;

  validFiles: Array<string> = ["png", "jpg", "jpeg", "pdf", "txt", "json"];
  requestAttachment: File = null;

  prioritiesColor: Array<string> = ["#999999", "#707070", "#f79232", "#f15C75", "#d04437"];
  statusColorMap: Map<string, string> = new Map();

  // Request Ownership
  requestOwnership: string = RequestOwnership.OWNED_REQUESTS;

  constructor(private apiService: ApiService, private supportApiService: SupportApiService, private authService: AuthenticationService, public utilService: UtilService, private toast: ToastService, private router: Router) {
    this.authService.authenticationState.subscribe(state => {
      console.log("logged in user details : ", this.authService.loggedInUser);
      if (state) {
        this.isLoggedIn = true;
        if (this.authService.isUserRoleAllowed()) {
          if (this.authService.isAdmin() || this.authService.isFinanceAdmin())
            this.isAdmin = true;
          else if (this.authService.isDeveloper())
            this.isDeveloper = true;
        } else {
          this.toast.showError("You don't have the permission to access this portal.");
          this.authService.logout();
          this.router.navigate(["/"]);
        }
      } else {
        this.isLoggedIn = false;
      }
      console.log("isAdmin::", this.isAdmin)
    });
  }

  public ngOnDestroy() {
    console.log("leaving the support coponent");
  }

  /***********************************
   * Initialization methods
   ************************************/

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.loggedInUser = this.authService.loggedInUser;
    this.initRequestOwnership();
    this.initTicketModal();
    this.initIndexPointers();
    this.initStatusColor();
    this.getSupportUser();
  }
  initRequestOwnership() {
    if (this.authService.isDeveloper() || this.authService.isFinanceAdmin()) {
      this.requestOwnership = RequestOwnership.OWNED_REQUESTS;
    } else {
      this.requestOwnership = RequestOwnership.ORGANIZATION;
    }
  }

  initOptions() {
    for (var i = 0; i < this.tickets.length; i++) {
      var ticket = this.tickets[i];
      var priority = this.getPriority(ticket.requestFieldValues);
      priority["color"] = this.getPriorityColor(priority);
      ticket["priority"] = priority;
      ticket["index"] = i;
      this.statusFilterOptions.add(ticket.currentStatus.status);
    }

    // Prepare master list
    this.masterTicketList = this.tickets;
    this.supportApiService.setSupportTickets(this.tickets);
    console.log("master ticket list::", this.masterTicketList);
  }

  initRequestCategoryFilterOption(requestCategories: Array<any>) {
    if (requestCategories == null || requestCategories == undefined || requestCategories.length < 1) return;
    requestCategories.forEach(category => {
      this.requestCategoryFilterOption.add(category.name);
    });
  }

  initPriorityFilterOption() {
    if (this.priorities == null || this.priorities == undefined || this.priorities.length < 1) return;
    this.priorities.forEach(priority => {
      this.priorityFilterOption.add(priority.name);
    });
  }

  initStatusColor() {
    this.statusColorMap.set("Waiting for support", "#0052CC");
    this.statusColorMap.set("In Progress", "#0052CC");
    this.statusColorMap.set("Waiting for customer", "#0052CC");
    this.statusColorMap.set("Pending", "#0052CC");
    this.statusColorMap.set("Escalated", "#0052CC");
    this.statusColorMap.set("In Review", "#0052CC");
    this.statusColorMap.set("Work in progress", "#0052CC");
    this.statusColorMap.set("Canceled", "#00875A");
    this.statusColorMap.set("Closed", "#00875A");
    this.statusColorMap.set("Done", "#00875A");
    this.statusColorMap.set("Completed", "#00875A");
    this.statusColorMap.set("Resolved", "#00875A");
    this.statusColorMap.set("Open", "#FFFFFF");
    this.statusColorMap.set("Reopened", "#FFFFFF");
  }

  initIndexPointers() {
    this.nextIndexPointer = 0;
    this.totalIssues = 0;
  }

  initTicketModal() {
    this.ticketFormData = {
      subject: null,
      comment: null,
      severity: null,
      serviceDesk: null,
      requestCategory: null,
      assignee: {
        name: null,
        image: null
      },
      priority: null
    }
  }

  /***********************************
   * API calling methods
   ************************************/

  getSupportUser() {
    this.utilService.showSpinner();
    this.supportApiService.getSupportUser(this.loggedInUser.userId).then((data) => {
      this.utilService.hideSpinner();
      this.supportUser = data;
      console.log("support user data::", this.supportUser);
      this.initIndexPointers();
      this.getServiceRequest(this.supportUser.supportUserId, this.supportUser.supportAccountId, this.maxIssueSize, this.nextIndexPointer);
      this.getRequestType();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getSupportUser();
        });
      } else {
        this.utilService.hideSpinner();
        /* if (error && error.error && error.error.message) this.toast.showError(error.error.message)
        else this.toast.showError(Constants.UNKNOWN_ERROR); */
      }
    });
  }

  addServiceRequest(payload: any) {
    this.utilService.showSpinner();
    this.supportApiService.addServiceRequest(this.supportUser.supportAccountId, payload).then((data) => {
      this.utilService.hideSpinner();
      if (this.requestAttachment != null && this.requestAttachment != undefined && data && data.issueId) {
        this.addAttachment(data.issueId);
      }
      this.resetAddTicketForm();
      console.log("add service response data::", data);
      this.initIndexPointers();
      this.getServiceRequest(this.supportUser.supportUserId, this.supportUser.supportAccountId, this.maxIssueSize, this.nextIndexPointer);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addServiceRequest(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  addAttachmentToRequest(formData: FormData, issueId: string) {
    console.log("attachment file::", this.requestAttachment);
    console.log("Attachment form data::", formData);
    this.utilService.showSpinner();
    this.supportApiService.addAttachmentToRequest(this.supportUser.supportUserId, issueId, formData, "Attachment").then((data) => {
      console.log("Response from add attachment request::", data);
      this.utilService.hideSpinner();
      this.requestAttachment = null;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addAttachmentToRequest(formData, issueId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getServiceRequest(userId: string, organizationId: string, maxResults: number, startAt: number) {
    this.utilService.showSpinner();
    this.supportApiService.getServiceRequest(userId, organizationId, this.requestOwnership, maxResults, startAt).then((data) => {
      console.log("get issue list response data::", data);
      this.tickets = data.values;

      this.isLastPage = data.isLastPage;
      this.initOptions();
      this.utilService.hideSpinner();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getServiceRequest(userId, organizationId, maxResults, startAt);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getRequestType() {
    this.utilService.showSpinner();
    if (this.supportUser && this.supportUser.serviceDesks && this.supportUser.serviceDesks.length > 0) {
      this.supportApiService.getRequestType(this.supportUser.serviceDesks[0].id).then((data) => {
        this.utilService.hideSpinner();
        console.log("get request type for servicedesk data::", data.values);
        this.requestCategories = this.prepareRequestCategoriesForUI(data.values);
        this.initRequestCategoryFilterOption(data.values);
        this.getRequestPriorities();
        this.prepareRequestTypeMap(data.values);
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.getRequestType();
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toast.showError(error.error.message);
          else this.toast.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  prepareRequestCategoriesForUI(values: Array<any>): Array<any> {
    if (values == null || values == undefined || values.length < 1) return;
    var reqCategory = new Array<any>();
    values.forEach(category => {
      if (category.groupIds.length > 0) {
        reqCategory.push(category);
      }
    });
    return reqCategory;
  }

  getRequestPriorities() {
    this.utilService.showSpinner();
    this.supportApiService.getRequestPriorities().then((data) => {
      this.utilService.hideSpinner();
      console.log("get request priorities", data);
      this.priorities = data;
      this.initPriorityFilterOption();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getRequestPriorities();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  /***********************************
   * Filters
   ************************************/

  onStatusFilter(option: string) {
    console.log("selected status filter option::", option);
    if (option == null || option == undefined) return;
    if (option.toLowerCase() == "status") return;
    if (option.toLowerCase() == "all") {
      this.tickets = this.masterTicketList;
    } else {
      var tickets = new Array();
      this.masterTicketList.forEach(element => {
        if (element.currentStatus.status == option)
          tickets.push(element);
      });
      this.tickets = tickets;
    }
  }

  onRequestCategoryFilter(option: string) {
    
    console.log("selected Request category filter option::", option);
    if (option == null || option == undefined) return;
    if (option.toLowerCase() == "request category") return;
    if (option.toLowerCase() == "all") {
      this.tickets = this.masterTicketList;
    } else {
      var tickets = new Array();
      this.masterTicketList.forEach(element => {
        let requestCategory = this.getRequestCategoryName(element.requestTypeId);
        if (requestCategory && (requestCategory.toLowerCase() == option.toLowerCase()))
          tickets.push(element);
      });
      this.tickets = tickets;
    }
  }

  onPriorityFilter(option: string) {
    console.log("selected Priority filter option::", option);
    if (option == null || option == undefined) return;
    if (option.toLowerCase() == "priority") return;
    if (option.toLowerCase() == "all") {
      this.tickets = this.masterTicketList;
    } else {
      var tickets = new Array();
      this.masterTicketList.forEach(element => {
        if (element.priority.name.toLowerCase() == option.toLowerCase())
          tickets.push(element);
      });
      this.tickets = tickets;
    }
  }

  /***********************************
   * Sorting methods
   ************************************/

  sortByDate(sortType: string) {
    let that = this;
    this.selectedDateSortType = sortType;
    this.tickets = this.tickets.sort(function (a, b) {
      if (sortType == that.sortType[0]) {
        return <any>new Date(b.createdDate.iso8601) - <any>new Date(a.createdDate.iso8601);
      } else {
        return <any>new Date(a.createdDate.iso8601) - <any>new Date(b.createdDate.iso8601);
      }
    });
  }

  onSortByDateClick() {
    console.log("sort by date clicked::", this.selectedDateSortType);
    //reset other selected sort type here
    this.selectedSeveritySortType = null;
    this.selectedStatusSortType = null;

    if (this.selectedDateSortType == this.sortType[0]) {
      this.sortByDate(this.sortType[1]);
      this.selectedDateSortType = this.sortType[1];
    } else {
      this.sortByDate(this.sortType[0]);
      this.selectedDateSortType = this.sortType[0];
    }
  }

  onSortBySeverityClick() {
    console.log("sort by vin clicked::", this.selectedSeveritySortType);
    //reset other selected sort type here
    this.selectedStatusSortType = null;
    this.selectedDateSortType = null;

    if (this.selectedSeveritySortType == this.sortType[0]) {
      this.selectedSeveritySortType = this.sortType[1];
      this.sortStringVal(this.sortType[1], "businessImpact");
    } else {
      this.selectedSeveritySortType = this.sortType[0];
      this.sortStringVal(this.sortType[0], "businessImpact");
    }
  }

  onSortByStatusClick() {
    console.log("sort by vin clicked::", this.selectedStatusSortType);
    //reset other selected sort type here
    this.selectedSeveritySortType = null;
    this.selectedDateSortType = null;

    if (this.selectedStatusSortType == this.sortType[0]) {
      this.selectedStatusSortType = this.sortType[1];
      this.sortStringVal(this.sortType[1], "status");
    } else {
      this.selectedStatusSortType = this.sortType[0];
      this.sortStringVal(this.sortType[0], "status");
    }
  }

  sortStringVal(sortType: string, fieldName: string) {
    let that = this;
    this.tickets = this.tickets.sort(function (a, b) {
      var val1 = a[fieldName].toLowerCase(), val2 = b[fieldName].toLowerCase();
      if (sortType == that.sortType[0]) {
        if (val1 < val2) return -1;
        if (val1 > val2) return 1;
        return 0;
      } else {
        if (val1 > val2) return -1;
        if (val1 < val2) return 1;
        return 0;
      }
    });
  }

  /***********************************
   * Pagination support methods
   ************************************/

  getNextIssues() {
    var nextIndexPointer = this.getNextIndexPointer();
    console.log("next index pointer:", nextIndexPointer);
    this.getServiceRequest(this.supportUser.supportUserId, this.supportUser.supportAccountId, this.maxIssueSize, nextIndexPointer);
  }

  getPreviousIssues() {
    var previousIndexPointer = this.getPreviousIndexPointer();
    this.getServiceRequest(this.supportUser.supportUserId, this.supportUser.supportAccountId, this.maxIssueSize, previousIndexPointer);
  }

  getNextIndexPointer(): number {
    if (!this.isLastPage) {
      this.nextIndexPointer = this.nextIndexPointer + this.maxIssueSize;
    }
    console.log("nextIndexPointer::", this.nextIndexPointer);
    return this.nextIndexPointer;
  }

  getPreviousIndexPointer(): number {
    if (this.nextIndexPointer != 0)
      this.nextIndexPointer = this.nextIndexPointer - this.maxIssueSize;
    return this.nextIndexPointer;
  }

  showNextButton(): boolean {
    return !this.isLastPage;
  }

  showPreviousButton(): boolean {
    if (this.nextIndexPointer != 0) return true;
    return false;
  }

  /***********************************
   * Other onClick methods
   ************************************/

  setDefaultPriority() {
    if (this.priorities != null && this.priorities != undefined && this.priorities.length > 0) {
      var index = this.priorities.findIndex(x => x.name === 'Medium');
      if (index != -1) {
        this.ticketFormData.priority = this.priorities[index];
      }
    }
  }

  onTicketDetailsSubmit() {
    console.log("Ticket data to save::", this.ticketFormData);
    var payload = {
      "raiseOnBehalfOf": this.supportUser.supportUserId,
      "requestFieldValues": {
        "description": this.ticketFormData.comment,
        "summary": this.ticketFormData.subject
      },
      "requestParticipants": [
      ],
      "requestTypeId": this.ticketFormData.requestCategory.id,
      "serviceDeskId": this.supportUser.serviceDesks[0].id
    };

    if (this.ticketFormData.priority != null && this.ticketFormData.priority != undefined) {
      payload.requestFieldValues["priority"] = {
        "id": this.ticketFormData.priority.id,
        "name": this.ticketFormData.priority.name
      };
    }

    console.log("Request payload for issue::", payload);
    this.addServiceRequest(payload);
  }

  resetAddTicketForm() {
    this.initTicketModal();
    this.addTicketDetailsForm.reset();
    this.addAttachmentInput.nativeElement.value = null;
    this.requestAttachment = null;
  }

  getRequestCategoryName(requestTypeId: string) {

    return this.requestTypeMap.get(requestTypeId);
  }

  getServiceDeskForIssue(serviceDeskId: string) {
    var serviceDesks = this.supportUser.serviceDesks;
    var desk = serviceDesks && serviceDesks.length > 0 ? serviceDesks.find(i => i.id === serviceDeskId) : null;
    if (desk != null && desk != undefined && desk.projectName)
      return desk.projectName;
    else return null;
  }

  getStatusColor(status: string): string {
    let color = this.statusColorMap.get(status);
    if (color == null || color == undefined) return "#FFFFFF";
    return color;
  }

  onAttachmentSelected(files: FileList) {
    this.requestAttachment = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      if (this.isAllowedFile(file.name)) {
        var fileSizeInMB = file.size / 1024 / 1024;
        console.log("actual file size : ", file.size, " - fileSizeInKB : ", fileSizeInMB, " - max file size limit in MB : ", Constants.SUPPORT_FILE_MAX_SIZE_MB);
        if (fileSizeInMB > 0 && fileSizeInMB < Constants.SUPPORT_FILE_MAX_SIZE_MB) {
          this.requestAttachment = file;
        } else {
          if (fileSizeInMB > Constants.SUPPORT_FILE_MAX_SIZE_MB) {
            this.toast.showError(Constants.SUPPORT_FILE_SIZE_ERROR_MESSAGE);
            return;
          } else {
            this.toast.showError(Constants.SUPPORT_FILE_SIZE_ZERO_ERROR_MESSAGE);
          }
        }
      }
    }
  }

  /***********************************
   * Miscellaneous
   ************************************/

  getPriority(requestFields: Array<any>) {
    if (requestFields == null || requestFields == undefined || requestFields.length < 0) {
      return {
        name: "",
        iconUrl: "",
        id: ""
      };
    }
    var index = requestFields.findIndex(x => x.fieldId === "priority");
    if (index < 0) return {
      name: "",
      iconUrl: "",
      id: ""
    };
    return requestFields[index].value;
  }

  getPriorityColor(priority: any) {
    let color = "";
    switch (priority.name) {
      case "Lowest": {
        color = this.prioritiesColor[0];
        break;
      }
      case "Low": {
        color = this.prioritiesColor[1];
        break;
      }
      case "Medium": {
        color = this.prioritiesColor[2];
        break;
      }
      case "High": {
        color = this.prioritiesColor[3];
        break;
      }
      case "Highest": {
        color = this.prioritiesColor[4];
        break;
      }
      default: {
        break;
      }
    }
    return color;
  }

  prepareRequestTypeMap(requestCategories: any) {
    if (requestCategories == null || requestCategories == undefined || requestCategories.length == 0) return;

    requestCategories.forEach(category => {
      
      this.requestTypeMap.set(category.id, category.name);
    });
  }

  isFileSelected(files: FileList) {
    if (files && files.length > 0)
      return true;
    return false;
  }

  isAllowedFile(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    if (!this.validFiles.includes(extension.toLowerCase())) {
      this.toast.showError("Please select valid files only.");
      return false;
    }
    return true;
  }

  addAttachment(issueId: string) {
    let formData: FormData = new FormData();
    formData.append('file', this.requestAttachment);
    this.addAttachmentToRequest(formData, issueId);
  }

  getRequestFieldValue(ticket, requestField: string): string {
    let value = "";
    let requestFieldValues: Array<any> = ticket.requestFieldValues;

    if (requestFieldValues && requestFieldValues.some(field => field.fieldId == requestField)) {
      value = requestFieldValues.find(field => field.fieldId == requestField).value;
    }

    return value ? value : "";
  }
}